export const environment = {
  production: false,
  //apiUrl: 'https://api.dev.ytdlp.attilab.duckdns.org'
  apiUrl: 'http://api.ytdlp.localhost'
};
